import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './components/App/App';
import { HelmetProvider } from 'react-helmet-async';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

// Get the #root container from index.html
const rootElement = document.getElementById('root');

// Create the React root and render the app
const root = ReactDOM.createRoot(rootElement);
root.render(
  
    <HelmetProvider>
      <BrowserRouter>
      <App />
      </BrowserRouter>
    </HelmetProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
reportWebVitals();
